@if (time?.hours) { {{ time?.hours < 10 ? '0' : '' }}{{ time.hours }}: }
<ng-container
  >{{ time?.minutes < 10 ? '0' : '' }}{{ time?.minutes }}:</ng-container
>
<ng-container
  >{{ time?.seconds < 10 ? '0' : '' }}{{ time?.seconds }}</ng-container
>
